module.exports = require("react-dom/server.edge");